import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`都市計畫系闖入軟體軟體領域的小獅子，`}</p>
    <p>{`擔任過系統分析師、專案經理、產品經理，目前正在挑戰商業開發，`}</p>
    <p>{`最擅長搭建領域知識和技術之間的橋樑，藉由溝通效率提高優化產品開發效率，讓軟體開發流程更順暢。`}</p>
    <p>{`部落格: `}<a parentName="p" {...{
        "href": "https://medium.com/@msli"
      }}>{`https://medium.com/@msli`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      